import React from 'react';
import ReactDOM from 'react-dom';
import classnames from 'classnames';
import { get } from 'lodash';

function CustomOverlay(map, config) {
	this.config = config;
	this.setMap(map);
}

export default function CreateCustomOverlay(google, map, config) {
	CustomOverlay.prototype = new google.maps.OverlayView();

	CustomOverlay.prototype.remove = function remove() {
		if (this.div) {
			this.div.parentNode.removeChild(this.div);
			this.div = null;
			this.setMap(null);
		}
	};

	CustomOverlay.prototype.update = function update(newConfig) {
		this.config = { ...this.config, ...newConfig };
		if (this.div)
			this.div.className = classnames(
				'custom-marker',
				this.config.className,
			);
	};

	CustomOverlay.prototype.draw = function draw() {
		let { div } = this;

		if (!div) {
			div = document.createElement('div');
			div.className = classnames('custom-marker', this.config.className);

			const panes = this.getPanes();
			panes.overlayImage.appendChild(div);

			if (this.config.label) {
				ReactDOM.render(<div>{this.config.label}</div>, div);
			}

			this.div = div;
		}

		const point = this.getProjection().fromLatLngToDivPixel(
			this.config.position,
		);
		div.style.left = `${get(point, 'x', 0)}px`;
		div.style.top = `${get(point, 'y', 0)}px`;
	};

	return new CustomOverlay(map, {
		...config,
		position: new google.maps.LatLng(
			config.location.latitude,
			config.location.longitude,
		),
	});
}
